import { EditOutlined } from '@mui/icons-material';
import { Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';

import { EditDateTimePickerProps } from './EditDateTimePicker.props';
import { 
  StyledTypography,
  StyledDateTimePicker
} from './EditDateTimePicker.styles';
import {
  Button,
  ButtonColorProps,
  ButtonSizeProps,
  ButtonVariantProps
} from '../../atoms/Button';

export const EditDateTimePicker: React.FC<EditDateTimePickerProps> = ({
  isEditable,
  disableFuture = false,
  disablePast = false,
  textColor = '',
  textFontSize = '',
  value,
  onChange
}) => {
  const [isShown, setIsShown] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (value !== textValue) {
      setTextValue(value);
    }
  }, [value]);

  const handleOnSubmit = () => {
    onChange(textValue);
    setIsEdit(false);
    setIsShown(false);
  };

  const handleCancel = () => {
    setTextValue(value);
    setIsEdit(false);
    setIsShown(false);
  };

  return (
    <Grid
      container 
      onMouseEnter={() => isEditable && setIsShown(true)}
      onMouseLeave={() => isEditable && setIsShown(false)}
      alignItems="center"
    >
      <Grid>
        {isEdit ?
          <StyledDateTimePicker
            label=""
            isCompact={true}
            disableFuture={disableFuture}
            disablePast={disablePast}
            value={textValue} 
            onChange={(val) => setTextValue(val)}
          />
          :
          <StyledTypography
            color={textColor}
            fontSize={textFontSize}
          >
            {value}
          </StyledTypography>
        }
      </Grid>
      {isEdit &&
        <Grid>
          <Button variant={ButtonVariantProps.Primary} color={ButtonColorProps.Success} onClick={handleOnSubmit} size={ButtonSizeProps.Small} className="extra-small-button">
            Save
          </Button>
          <Button variant={ButtonVariantProps.Secondary} color={ButtonColorProps.Error} onClick={handleCancel} size={ButtonSizeProps.Small} className="extra-small-button">
            Cancel
          </Button>
        </Grid>
      }
      {isShown && !isEdit &&
        <Button
          variant={ButtonVariantProps.Icon}
          size={ButtonSizeProps.Small}
          onClick={() => setIsEdit(true)}
        >
          <EditOutlined fontSize="small" color={ButtonColorProps.Warning} />
        </Button>
      }
    </Grid>
  );
};
